export default __webpack_public_path__ + "static/media/bottom-nav-bg.91cacf1d.png";